import './hydromet.css';
import {IComponentOptions} from 'angular';
import {UrlRouterProvider, StateProvider} from 'angular-ui-router';

const template = require<string>('./hydromet.html');

export const hydrometComponent: IComponentOptions = {
  template
};

export const configStates = ($stateProvider: StateProvider,
                             $urlRouterProvider: UrlRouterProvider) => {
  $stateProvider.state('home', {
    component: 'hydrometHome',
    url: '/home'
  });
  $stateProvider.state('login', {
    component: 'imomoLogin',
    url: '/login'
  });
  $stateProvider.state('help', {
      component: 'hydrometHelp',
      url: '/help'
  });
    $stateProvider.state('about', {
        component: 'hydrometAbout',
        url: '/about'
    });
    $stateProvider.state('organization', {
        component: 'hydrometOrganization',
        url: '/organization/:id'
    });
    $stateProvider.state('user-management', {
        component: 'userManagement',
        url: '/users'
    });
    $stateProvider.state('user-details', {
        component: 'userDetails',
        url: '/users/:id'
    });
    $stateProvider.state('reset-password', {
        component: 'resetPassword',
        url: '/reset-password/'
    });

    $stateProvider.state('access', {
        component: 'access',
        url: '/access'
    });

    $stateProvider.state('invitations', {
        component: 'hydrometInvitations',
        url: '/invitations/'
    });

  $urlRouterProvider.when('/', '/home').otherwise('/home');
};
configStates.$inject = ['$stateProvider', '$urlRouterProvider'];



/** WEBPACK FOOTER **
 ** ./app/hydromet/hydromet.component.ts
 **/